import React from 'react';
import Marquee from 'react-fast-marquee';
import { ShieldCheck, Star, Lock, Award, CheckCircle, Globe } from 'lucide-react';

const badges = [
  { icon: ShieldCheck, label:"USPTO Authorized" },
  { icon: Award, label:"BBB Accredited" },
  { icon: Star, label:"4.9/5 Trustpilot" },
  { icon: Globe, label:"Google Reviews" },
  { icon: Lock, label:"256-bit Encrypted" },
  { icon: CheckCircle, label:"Money-Back Guarantee" },
];

const TrustBadgesSection = () => (
  <section data-testid="trust-badges-section" className="py-5 bg-white border-y border-[#EDE9FE]">
    <Marquee speed={25} gradient={true} gradientColor="white" gradientWidth={60}>
      {badges.map((b,i)=>(
        <div key={i} data-testid={`trust-badge-${i}`} className="flex items-center gap-2.5 mx-10">
          <b.icon className="w-4 h-4 text-[#6366F1]/50" strokeWidth={1.5} />
          <span className="text-xs font-medium text-[#4B5563]/60 whitespace-nowrap tracking-wide uppercase" style={{fontWeight:600,letterSpacing:'0.05em'}}>{b.label}</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default TrustBadgesSection;
